import ReferralConfirmation from './ReferralConfirmation'
import ReferralForm from './ReferralForm'

export { ReferralConfirmation, ReferralForm }

export default ReferralConfirmation
